import { Model } from "@vuex-orm/core";
import type { Fields } from "@vuex-orm/core";
import type { Config } from "@vuex-orm/plugin-axios";

import Video from "@models/Video";
import VideoExport from "@models/VideoExport";

export default class Publication extends Model {
  // This is the name used as module name of the Vuex Store.
  public static entity = "publications";

  public static get apiConfig(): Config {
    return {
      // headers: { 'X-Requested-With': 'XMLHttpRequest' },
      baseURL: "/api/v1/publications",
    };
  }

  public static fields(): Fields {
    return {
      id: this.number(-1),
      createdAt: this.attr(""),
      status: this.string(""),
      videoId: this.number(null).nullable(),
      video: this.belongsTo(Video, "videoId"),
      isCurrent: this.boolean(false),
      url: this.string(""),
      videoExports: this.hasMany(VideoExport, "publicationId"),
    };
  }

  public declare id: number;

  public declare createdAt: string;

  public declare status: string;

  public declare videoId: number | null;

  public declare video: Video;

  public declare isCurrent: boolean;

  public declare url: string;

  public declare videoExports: VideoExport[];
}
